import { OrderInspectionBy } from '../../inspection/models/find-inspection.model';
export class SearchImplementInspectionItem {
    public customer: number[] = [];
    public jobsite: number[] = [];
    public equipment: number[] = [];
    public make: number[] = [];
    public model: number[] = [];
    public implement: number[] = [];
    public ImplementTypes:number[]=[];
    public ComponentTypes:number[]=[];
    public evalA: boolean = true;
    public evalB: boolean = true;
    public evalC: boolean = true;
    public evalX: boolean = true;
    public onEq:number=3;
    public family: number[] = [];
    public assetSerial:number[]=[];
    public startDate: Date = new Date(Date.now());
    public endDate: Date = new Date(Date.now());
}

export class ImplementInspectionSearchResult {
    public TotalRecords: number;
    public implementInspectionResult: ImplementInspectionRowViewModel[];
  }
  
  export class EqAndInspectionIds{
    public EquipmentId:number;
    public InspectionId:number;
  }
  export class ImplementInspectionRowViewModel {
    constructor(
      public Dealer: string,
      public Examiner: string,
      public CustomerName: string,
      public Evaluation: string,
      public Eval_:string,
      public Family: string,
      public InspectionDate: Date,
      public JobsiteName: string,
      public Make: string,
      public Model: string,
      public SerialNumber: string,
      public UnitNumber: string,
      public EquipmentID:number,
      public IsChain:boolean
      ) { }
  }
  
  export class ImplementInspectionSearchRequest {
    constructor(
      public PageNumber: number,
      public InspectionsPerPage: number,
      public SearchItems: SearchImplementInspectionItem,
      public OrderBy: OrderInspectionBy,
    ) {}
  }
  
  
  export enum SortOptions {
    Eval,
    InspectionDate,
    SerialNumber,
    UnitNumber,
    Customer,
    Jobsite,
    Make,
    Model,
    Family,
    Examiner = 11,
  }
  
  
  export enum ViewedInspectionTypes {
   GeneralInspection,
   UnsyncInspection,
   RepairEstimates,
  }

  export class FamilyList {
    Id: number;
    Name: string;
}
